import { ActionStatus } from '@parapet/common';
import * as types from './types';

export interface PasswordState {
  setPasswordStatus: ActionStatus;
  validateTokenStatus: ActionStatus;
}

const initialState: PasswordState = {
  setPasswordStatus: ActionStatus.default,
  validateTokenStatus: ActionStatus.default,
};

export function passwordReducer(
  state = initialState,
  action: types.ActionTypes,
): PasswordState {
  switch (action.type) {
    case types.VALIDATE_PASSWORD_TOKEN:
      return { ...state, validateTokenStatus: ActionStatus.loading };

    case types.VALIDATE_PASSWORD_TOKEN_SUCCESS:
      return { ...state, validateTokenStatus: ActionStatus.success };

    case types.VALIDATE_PASSWORD_TOKEN_FAILURE:
      return { ...state, validateTokenStatus: ActionStatus.failure };

    case types.SET_PASSWORD:
      return { ...state, setPasswordStatus: ActionStatus.loading };

    case types.SET_PASSWORD_SUCCESS:
      return { ...state, setPasswordStatus: ActionStatus.success };

    case types.SET_PASSWORD_FAILURE:
      return { ...state, setPasswordStatus: ActionStatus.failure };

    default:
      return state;
  }
}
